export enum RichResultsTypes {
  Thing = 'Thing',
  Organization = 'Organization',
  Person = 'Person',
  Product = 'Product',
  Offer = 'Offer',
  AggregateOffer = 'AggregateOffer',
  Review = 'Review',
  CriticReview = 'CriticReview',
  AggregateRating = 'AggregateRating',
  BreadcrumbList = 'BreadcrumbList',
  FAQPage = 'FAQPage',
  QAPage = 'QAPage',
  ItemList = 'ItemList',
  ListItem = 'ListItem',
  SoftwareApplication = 'SoftwareApplication',
  ImageObject = 'ImageObject',
  Dataset = 'Dataset',
  Article = 'Article',
  HowToSection = 'HowToSection',
  WebPageElement = 'WebPageElement',
  WebPage = 'WebPage',
  Question = 'Question',
  Answer = 'Answer',
  VideoObject = 'VideoObject'
}

export enum AvailabilityType {
  InStock = 'InStock',
  OutOfStock = 'OutOfStock',
  PreOrder = 'PreOrder',
  SoldOut = 'SoldOut',
}
